import React from 'react';
import propTypes from 'prop-types';

import MediaPagePhotoGalleryListItem from './MediaPagePhotoGalleryListItem';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const MediaPagePhotoGalleryList = ( { items } ) => (
  <>
    { items === null && <LoadingSpinner /> }

    { items?.map( ( item, index ) => (
      <MediaPagePhotoGalleryListItem
        key={item.uuid}
        item={item}
        index={index}
      />
    ) )}
  </>
);

MediaPagePhotoGalleryList.propTypes = {
  items: propTypes.arrayOf(
    propTypes.shape( {
      uuid: propTypes.string,
      title: propTypes.string,
      coverImage: propTypes.string,
    } ),
  ),
};

MediaPagePhotoGalleryList.defaultProps = {
  items: [],
};

export default MediaPagePhotoGalleryList;
